const { fetcher } = require('services/helpers/responseHandler')

const tryLogin = ({
  hotelId,
  credentialString,
  IsOverwriteExistingCredentials = false
}) =>
  fetcher.post('merchants/trylogin', {
    hotelId,
    credentialString,
    IsOverwriteExistingCredentials
  })

const pmsSyncStatus = () => fetcher.get('subsidiaries/pmssyncstatus')

const steps = ({ isWholeGroup = false, merchantId }) =>
  fetcher.get(
    'merchantcontracts/steps',
    isWholeGroup ? { isWholeGroup, merchantId } : { isWholeGroup }
  )

const finalDetails = () => fetcher.get(`merchantcontracts/setup-finalize`)

const getAchAuthForm = () =>
  fetcher.post(`merchantcontracts/ach-auth-form`, {
    isPreOnboarding: true,
    regenerate: true
  })

const sendAchForm = ({ userId, regenerate }) =>
  fetcher.post(`merchantcontracts/ach-auth-form`, {
    isPreOnboarding: false,
    dashboardUserId: userId,
    sendEmail: true,
    regenerate: !!regenerate
  })

const checkAchAuthForm = () => fetcher.get(`merchantcontracts/ach-auth-form/sign/check`)

const hotelSetupApi = {
  tryLogin,
  pmsSyncStatus,
  steps,
  finalDetails,
  getAchAuthForm,
  sendAchForm,
  checkAchAuthForm
}

export default hotelSetupApi
